import {PROOM_ORIGIN} from 'app/utils/proom/proomUrl';

let pendingUserTokenRefresh: Promise<string> | null = null;

export const requestUserTokenRefresh = (): Promise<string> => {
    if (pendingUserTokenRefresh) {
        return pendingUserTokenRefresh;
    }

    const csrfMeta = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
    const csrf = csrfMeta?.content || '';

    pendingUserTokenRefresh = fetch('/poker/user_token', {
        credentials: 'same-origin',
        headers: {Accept: 'application/json', 'X-CSRF-Token': csrf},
        method: 'POST'
    })
        .then(r => r.ok ? r.json() : Promise.reject(r.status))
        .then(({userToken}: {userToken: string}) => userToken)
        .finally(() => {
            pendingUserTokenRefresh = null;
        });

    return pendingUserTokenRefresh;
};

export const broadcastUserToken = (userToken: string, iframes: HTMLIFrameElement[]): void => {
    const message = {type: 'proom:user-token', userToken};

    iframes.forEach(iframe => {
        iframe.contentWindow?.postMessage(message, PROOM_ORIGIN);
    });
};

interface IframeRef {
    current: HTMLIFrameElement | null
}

export const getIframeElements = (
    refs: Array<IframeRef | HTMLIFrameElement | null | undefined>
): HTMLIFrameElement[] => refs
    .map(ref => {
        if (!ref) {
            return null;
        }

        if ('current' in ref) {
            return ref.current;
        }

        return ref;
    })
    .filter((iframe): iframe is HTMLIFrameElement => iframe !== null);
